<template>

    <div class="img-holder lazyload" @mouseover="hover = true" @mouseleave="hover = false" data-scroll>
      <img :src="image" :id="image"/>
      <shareBtns v-if="phone || hover" :image="image"/> 
    </div>

</template>

<script>
	import shareBtns from './share-buttons';
	import ScrollOut from "scroll-out";

	export default {
		name: 'imgHolder',
		props: [ 'image' ],
		data() {
			return {
				hover: false,
				phone: false,
			};
		},
		components: {
			shareBtns
		},
		mounted() {
			if (window.innerWidth < 1100) {
				this.phone = true;
			}

			ScrollOut({
				threshold: .2,
				once: true
			});
		}
	}
</script>